/* eslint-disable */
export default {
  cancel: '取消',
  close: '關閉',
  ok: '確定',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
